import React, { useEffect, useState } from 'react'
import { toast, ToastContainer } from 'react-toastify';
import 'common/css/master.css';
import './questionPaper.css';
import ExamPatternPopup from './examPattern';

import { getExamSyllabusSubjectList, saveExamPatternSvc } from './questionPaperSvc';


function ExamSubjectTbl(props) {
    const { lstPattern, examId, syllabusId, setLoader, setOpacity, key, updateKey } = props;

    const [subjectId, setSubjectId] = useState(0);
    const [isPopupVisible, setIsPopupVisible] = useState(false);
    const [subject, setSubject] = useState("");
    const [lstSubject, setLstSubject] = useState([]);
    const [patternId, setPatternId] = useState(0);



    useEffect(() => {
        // console.log("ExamSubjectTbl called examId", examId, ", syllabusId", syllabusId);
        if (examId && syllabusId) {
            getExamSubjectList(examId, syllabusId);
        }
    }, [examId, syllabusId, key]);

    const saveExamSubjects = () => {
        // console.log("saveExamSubjects called");
        const saveExamSubjectPattern = {
            examId,
            syllabusId,
            lstSubject: lstSubject.map(subject => ({
                examSubjectId: subject.examSubjectId,
                subjectId: subject.subjectId,
                maxMarks: subject.maxMarks,
                passingMarks: subject.passingMarks,
                patternId: subject.patternId,
                duration: subject.duration,
            }))
        };
        // console.log("saveExamSubjectPattern", saveExamSubjectPattern);
        saveExamPatternSvc(saveExamSubjectPattern, saveExamSubjectPatternResponse);
    };


    const saveExamSubjectPatternResponse = (data) => {
        // console.log("saveExamSubjectPatternResponse called");
        if (data.status === "Success") {
            toast.success(data.message);
            updateKey();
        } else if (data.status === "Failure") {
            handleServiceError(data.message);
        } else {
            toast.error("Service failed " + data.error);
        }
        setLoader("none");
        setOpacity(1);
    }

    const getExamSubjectList = (pExamId, pSyllaubusId) => {
        // console.log("getExamSubjectList called");
        setLoader("block");
        setOpacity(0.5);
        getExamSyllabusSubjectList(pExamId, pSyllaubusId, examSubjectListResponse);
    }

    const examSubjectListResponse = (data) => {
        // console.log("examSubjectListResponse called");
        if (data.status === "Success") {
            setLstSubject(data.lstSubject);
        } else if (data.status === "Failure") {
            handleServiceError(data.message);
        } else {
            toast.error("Service failed " + data.error);
        }
        setLoader("none");
        setOpacity(1);
    }

    const handleServiceError = (svcMsg) => {
        if (svcMsg === "You are not Logged In") {
            toast.error("You are not logged in. Redirecting to login page...");
            setTimeout(() => {
                window.location.href = "/";
            }, 2000);
        } else if (svcMsg === "Server Timed Out, Login Again") {
            toast.error("Server timed out. Redirecting to login page...");
            setTimeout(() => {
                window.location.href = "/";
            }, 2000);
        } else {
            toast.error(svcMsg);
        }
    };

    const openPopup = () => {
        // console.log("openPopup called");
        setIsPopupVisible(true);
        // setOpacity(0.5);
    }

    const closePopup = () => {
        // console.log("closePopup called");
        setIsPopupVisible(false);
        setPatternId(0);
        // setOpacity(1);
    }

    const changePattern = async (pSubject) => {
        // console.log("changePattern called, pSubject", pSubject);
        await setSubject(pSubject.subject);
        await setSubjectId(pSubject.subjectId);
        await setPatternId(pSubject.patternId);
        openPopup();
    }

    const handleValueChange = async (pSubjectId, pName, pValue) => {
        // console.log("handleValueChange called");
        // console.log("pSubjectId", pSubjectId);
        // console.log("pName", pName);
        // console.log("pValue", pValue);
        const updatedLstSubject = lstSubject.map(subject =>
            subject.subjectId === pSubjectId
                ? { ...subject, [pName]: Number(pValue) } // Update the field dynamically
                : subject // Return unchanged subject
        );
        // console.log("updatedLstSubject", updatedLstSubject);
        await setLstSubject(updatedLstSubject);
    }

    const handlePatternIdChange = async (pSubjectId, pPatternId, pPattern, pSections) => {
        // console.log("handlePatternIdChange called");
        // console.log("lstSubject", lstSubject);
        // console.log("pSubjectId", pSubjectId);
        // console.log("pPatternId", pPatternId);
        // console.log("pPattern", pPattern);
        const updatedLstSubject = lstSubject.map(subject =>
            subject.subjectId === pSubjectId
                ? { ...subject, "patternId": Number(pPatternId), "pattern": pPattern, "countSections": pSections } // Update the field dynamically
                : subject // Return unchanged subject
        );
        // console.log("updatedLstSubject", updatedLstSubject);
        await setLstSubject(updatedLstSubject);
        closePopup()
    }



    const colgrp = <colgroup>
        <col width="80"></col>
        <col width="30"></col>
        <col width="30"></col>
        <col width="30"></col>
        <col width="50"></col>
        <col width="30"></col>
        <col width="30"></col>
    </colgroup>

    return (
        <div >
            <div className="col-md-12 col-xs-12 col-sm-12 col-centered padding-remove" >
                <table className='tableLayout1'>
                    {colgrp}
                    <thead>
                        <tr>
                            <th className='padding-remove'>Subject</th>
                            <th className='padding-remove'>Max Marks</th>
                            <th className='text-center'>Passing Marks</th>
                            <th className='text-center'>Duration</th>
                            <th className='text-center'>Pattern</th>
                            <th className='text-center'>Questions</th>
                            <th className='text-center'>Sections</th>
                        </tr>
                    </thead>
                </table>
                <div className="tableDiv" style={{ height: "50vh" }}>
                    <table className="tableLayout">
                        {colgrp}
                        <tbody id="examSubjectTable" >
                            {lstSubject &&
                                lstSubject.map((subject, idx) => (
                                    <tr key={subject.subjectId + "_" + idx}
                                        onClick={() => setSubjectId(subject.subjectId)}
                                        className={subject.subjectId === subjectId ? "selected" : ''}>
                                        <td className="text-left">{subject.subject}</td>
                                        <td className="text-center">
                                            <input
                                                type="number"
                                                className="form-control "
                                                style={{
                                                    width: "80%",
                                                    marginLeft: "10%",
                                                    textAlign: "right",
                                                }}
                                                id="maxMarks"
                                                value={subject.maxMarks}
                                                placeholder="0"
                                                onChange={(e) =>
                                                    handleValueChange(subject.subjectId, "maxMarks", e.target.value)
                                                }
                                            />
                                        </td>
                                        <td className="text-center">
                                            <input
                                                type="number"
                                                className="form-control "
                                                style={{
                                                    width: "80%",
                                                    marginLeft: "10%",
                                                    textAlign: "right",
                                                }}
                                                id="maxMarks"
                                                value={subject.passingMarks}
                                                placeholder="0"
                                                onChange={(e) =>
                                                    handleValueChange(subject.subjectId, "passingMarks", e.target.value)
                                                }
                                            />
                                        </td>
                                        <td className="text-center">
                                            <input
                                                type="number"
                                                className="form-control "
                                                style={{
                                                    width: "80%",
                                                    marginLeft: "10%",
                                                    textAlign: "right",
                                                }}
                                                id="maxMarks"
                                                value={subject.duration}
                                                placeholder="0"
                                                onChange={(e) =>
                                                    handleValueChange(subject.subjectId, "duration", e.target.value)
                                                }
                                            />
                                        </td>
                                        <td className="text-center">
                                            <span
                                                onClick={() => changePattern(subject)}
                                                title="Edit Exam Pattern"
                                                style={{ textDecoration: "underline", cursor: "pointer", color: "blue", margin: "5px" }}
                                            >
                                                {subject.pattern || "select pattern"}
                                            </span>
                                        </td>
                                        <td className="text-center">{subject.totalQuestions}
                                        </td>
                                        <td className="text-center">
                                            {subject.countSections}
                                        </td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </table>
                </div>
            </div>
            <div className="col-md-12 col-xs-12 col-sm-12 col-centered padding-remove" style={{ height: "50px", marginTop: "15px" }}>
                <div className="col-sm-2 col-xs-3 padding-remove text-right pull-right">
                    <button
                        type="button"
                        className="btn btn-info"
                        onClick={() => saveExamSubjects()}
                    >
                        Save
                    </button>
                </div>
            </div>
            {
                isPopupVisible ?
                    <ExamPatternPopup
                        lstPattern={lstPattern}
                        subjectId={subjectId}
                        subject={subject}
                        patternId={patternId}
                        handlePatternIdChange={handlePatternIdChange}
                        closePopup={closePopup}
                    />

                    : null
            }
        </div>
    )
}

export default ExamSubjectTbl;